import { Resource as a, API as i } from "@coveo/platform-client";
const t = class t extends a {
  list(e) {
    return this.api.get(this.buildPath(t.baseUrl, e));
  }
  get(e) {
    return this.api.get(`${t.baseUrl}/${e}`);
  }
  create(e) {
    return this.api.post(t.baseUrl, e);
  }
  update(e, s) {
    return this.api.put(`${t.baseUrl}/${e}`, s);
  }
  delete(e) {
    return this.api.delete(`${t.baseUrl}/${e}`);
  }
  /**
   * Generates all missing facet field configurations for a trackingId.
   * @param trackingId
   */
  generate(e) {
    return this.api.post(
      this.buildPath(`${t.baseUrl}/generate`, { trackingId: e })
    );
  }
};
t.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/private/v2/configurations/facets/fields`;
let r = t;
export {
  r as FacetFieldConfigurations
};
//# sourceMappingURL=FacetFieldConfigurations.js.map
